import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import {
  exportImageScaleFactor,
  exportImageUnit,
  imageSizes,
} from './constants';

export const getImageWidth = (
  size: ExportFormFields['size'],
  orientation: ExportFormFields['orientation'],
): number => imageSizes[size]['imageWidth'][orientation];

export const calculateImageHeight = (
  canvas: HTMLCanvasElement,
  imageWidth: number,
): number => (canvas.height * imageWidth) / canvas.width;

export const calculateVerticalMargin = (
  pdf: jsPDF,
  imageHeight: number,
): number => (pdf.internal.pageSize.height - imageHeight) / 2;

export const createNewJsPdf = (
  size: ExportFormFields['size'],
  orientation: ExportFormFields['orientation'],
): jsPDF => {
  return new jsPDF(orientation, exportImageUnit, size);
};

export const exportImage = async (
  type: ExportFormFieldsTypeImage,
): Promise<void> => {
  const canvas = await html2canvas(
    document.getElementById('root') as HTMLElement,
    { scale: exportImageScaleFactor, useCORS: true },
  );

  const imageDataURL = canvas.toDataURL(`image/${type}`);
  const exportLinkElement = document.createElement('a');
  exportLinkElement.href = imageDataURL;
  exportLinkElement.download = 'diagram-export';
  exportLinkElement.click();
};

export const determineIsExportTypePdf = (
  type: ExportFormFields['type'],
): boolean => type === 'pdf';

export const determineCurrentTheme = (): string => {
  return document.body.getAttribute('data-theme') ?? 'dark';
};

export const determineTopologyTitleOverflowCoordinate = (
  size: ExportFormFields['size'],
  orientation: ExportFormFields['orientation'],
): number => imageSizes[size]['topologyTitleOverflowCoordinate'][orientation];
